var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "26px",
    viewBox: "0 0 42 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4D66FC82-B0E9-4160-9689-4B20ABD010BE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-2:-SecurionPay",
    transform: "translate(-59.000000, -318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards",
    transform: "translate(16.000000, 318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mastercard-icon",
    transform: "translate(43.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#C4C5C6",
    strokeWidth: 0.3,
    fill: "#FFFFFF",
    x: 0.37283237,
    y: 0.216763006,
    width: 41,
    height: 25,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "mc_symbol",
    transform: "translate(6.372832, 4.216763)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 27.2070202,
    height: 17.7187406
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF5F00",
    x: 9.98717949,
    y: 3.13043478,
    width: 7.35897436,
    height: 11.4782609
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8126052,8.86855074 C10.8107988,6.62757164 11.8632337,4.51023206 13.6666667,3.12661167 C10.6029179,0.77303585 6.20325172,1.11585452 3.55963535,3.91414394 C0.916018985,6.71243336 0.916018985,11.0266971 3.55963535,13.8249865 C6.20325172,16.6232759 10.6029179,16.9660946 13.6666667,14.6125188 C11.8626598,13.228459 10.8101606,11.1102418 10.8126052,8.86855074 Z",
    id: "Path",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9469231,14.0869565 L24.9469231,13.2223602 L25.1221368,13.2223602 L25.1221368,13.0434783 L24.7051282,13.0434783 L24.7051282,13.2223602 L24.8698291,13.2223602 L24.8698291,14.0869565 L24.9469231,14.0869565 Z M25.7564103,14.0869565 L25.7564103,13.0434783 L25.6302564,13.0434783 L25.4830769,13.7888199 L25.3358974,13.0434783 L25.2097436,13.0434783 L25.2097436,14.0869565 L25.3008547,14.0869565 L25.3008547,13.2968944 L25.4375214,13.9751553 L25.5321368,13.9751553 L25.6688034,13.2968944 L25.6688034,14.0869565 L25.7564103,14.0869565 Z",
    id: "Shape",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7564103,8.87057958 C25.7564103,11.666861 24.1228775,14.2176433 21.5497513,15.4395992 C18.9766252,16.6615552 15.9155852,16.3401545 13.6666667,14.6118972 C15.4691489,13.2272521 16.5215674,11.1104231 16.5215674,8.86956522 C16.5215674,6.62870733 15.4691489,4.51187837 13.6666667,3.1272332 C15.9155852,1.39897591 18.9766252,1.0775752 21.5497513,2.29953119 C24.1228775,3.52148718 25.7564103,6.0722694 25.7564103,8.86855085 L25.7564103,8.87057958 Z",
    id: "Path",
    fill: "#F79E1B"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.6d8bd655c05e25a208200ae0402e9cba.svg";
export { ForwardRef as ReactComponent };